// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { addressDrawerPickUpLocationSelectorStyles } from "@insite/content-library/Widgets/Header/AddressDrawerPickUpLocationSelector";
import { css } from "styled-components";

addressDrawerPickUpLocationSelectorStyles.changeLink = {
    typographyProps: {
        size: 12,
        lineHeight: "17px",
        weight: fontConfig.weight.bold,
    },
    css: css`
        margin-left: 16px;
    `,
};

addressDrawerPickUpLocationSelectorStyles.headerText = {
    variant: "h6",
    css: css`
        display: inline-block;
    `,
};
